import React from "react";
import { Select } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";
import("./Fonts.css");

const AVAILABLE_FONTS = [
  "Arial",
  "Helvetica",
  "Roboto",
  "Open Sans",
  "Poppins",
  "Lato",
  "Montserrat",
  "Raleway",
  "Ubuntu",
];

const styles = {
  row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: 20,
  },
  sample: {
    color: "var(--sl-text-primary)",
  },
  sampleHeader: {
    margin: 0,
    fontSize: 24,
    fontWeight: 700,
  },
  sampleText: {
    margin: "4px 0 0",
    fontSize: 14,
    color: "var(--sl-text-secondary)",
  },
};

const FontSelect = () => {
  const {
    formState,
    setFormState,
  } = useMarketingSettingsContext();

  const handleFontChange = (value) => {
    setFormState((prev) => ({
      ...prev,
      font_family: value,
    }));
  };

  return (
    <div style={styles.row}>
      <Select
        aria-label="Font"
        width={240}
        options={AVAILABLE_FONTS.map((font) => ({ value: font, label: font }))}
        value={formState.font_family || null}
        onChange={handleFontChange}
      />
      <div className={`${formState.font_family?.toLowerCase().replace(" ", "-")}-font`} style={styles.sample}>
        <h3 style={styles.sampleHeader}>Sample Header</h3>
        <p style={styles.sampleText}>Sample text</p>
      </div>
    </div>
  );
};

export default FontSelect;
